import { createExcelAndDownload } from '../../../../utils/reportExcelExport';

export function Report(subscriptions) {
    const customHeadings = [
        { key: "renewal_frequency", label: "Subscription Type" },
        { key: "member_id.member_id", label: "Member ID" },
        { key: "member_id.name", label: "Member Name" },
        { key: "member_id.balance", label: "Balance" },
        { key: "end_date", label: "Subscription End Date", isDate: true },
        { key: "is_active", label: "Status" },
    ];
    createExcelAndDownload("All Subscriptions Report", subscriptions, customHeadings, {
        transformCell: (key, value) => {
            if (key === "is_active") {
                return value ? "Active" : "Expired";
            }
            return value;
        },
    });
}
